var map = {
	"./addinformation/addinformation.module": [
		"./src/app/components/auth/addinformation/addinformation.module.ts",
		"default~addinformation-addinformation-module~dashboard-dashboard-module~dashboards-dashboards-module~e00834a1",
		"default~addinformation-addinformation-module~editinformation-editinformation-module~pages-pages-modu~6c7517f9",
		"default~addinformation-addinformation-module~editinformation-editinformation-module~previewreports-p~3082fc9b",
		"default~addinformation-addinformation-module~pages-pages-module~viewinformation-viewinformation-modu~777c1151",
		"default~addinformation-addinformation-module~viewinformation-viewinformation-module",
		"addinformation-addinformation-module"
	],
	"./components/auth/auth.module": [
		"./src/app/components/auth/auth.module.ts",
		"components-auth-auth-module"
	],
	"./components/non-auth/non-auth.module": [
		"./src/app/components/non-auth/non-auth.module.ts",
		"components-non-auth-non-auth-module"
	],
	"./dashboard/dashboard.module": [
		"./src/app/components/auth/dashboard/dashboard.module.ts",
		"default~addinformation-addinformation-module~dashboard-dashboard-module~dashboards-dashboards-module~e00834a1",
		"default~dashboard-dashboard-module~dashboards-dashboards-module",
		"dashboard-dashboard-module"
	],
	"./dashboards/dashboards.module": [
		"./src/app/components/auth/dashboards/dashboards.module.ts",
		"default~addinformation-addinformation-module~dashboard-dashboard-module~dashboards-dashboards-module~e00834a1",
		"default~dashboard-dashboard-module~dashboards-dashboards-module",
		"dashboards-dashboards-module"
	],
	"./editinformation/editinformation.module": [
		"./src/app/components/auth/editinformation/editinformation.module.ts",
		"default~addinformation-addinformation-module~dashboard-dashboard-module~dashboards-dashboards-module~e00834a1",
		"default~addinformation-addinformation-module~editinformation-editinformation-module~pages-pages-modu~6c7517f9",
		"default~addinformation-addinformation-module~editinformation-editinformation-module~previewreports-p~3082fc9b",
		"editinformation-editinformation-module"
	],
	"./issuedocs/issuedocs.module": [
		"./src/app/components/auth/issuedocs/issuedocs.module.ts",
		"issuedocs-issuedocs-module"
	],
	"./pages/pages.module": [
		"./src/app/components/auth/pages/pages.module.ts",
		"default~addinformation-addinformation-module~dashboard-dashboard-module~dashboards-dashboards-module~e00834a1",
		"default~addinformation-addinformation-module~editinformation-editinformation-module~pages-pages-modu~6c7517f9",
		"default~addinformation-addinformation-module~pages-pages-module~viewinformation-viewinformation-modu~777c1151",
		"default~pages-pages-module~previewreports-previewreports-module~viewinformation-viewinformation-modu~726601f2",
		"pages-pages-module"
	],
	"./previewreports/previewreports.module": [
		"./src/app/components/auth/previewreports/previewreports.module.ts",
		"default~addinformation-addinformation-module~dashboard-dashboard-module~dashboards-dashboards-module~e00834a1",
		"default~addinformation-addinformation-module~editinformation-editinformation-module~pages-pages-modu~6c7517f9",
		"default~addinformation-addinformation-module~editinformation-editinformation-module~previewreports-p~3082fc9b",
		"default~pages-pages-module~previewreports-previewreports-module~viewinformation-viewinformation-modu~726601f2",
		"previewreports-previewreports-module"
	],
	"./viewinformation/viewinformation.module": [
		"./src/app/components/auth/viewinformation/viewinformation.module.ts",
		"default~addinformation-addinformation-module~dashboard-dashboard-module~dashboards-dashboards-module~e00834a1",
		"default~addinformation-addinformation-module~editinformation-editinformation-module~pages-pages-modu~6c7517f9",
		"default~addinformation-addinformation-module~editinformation-editinformation-module~previewreports-p~3082fc9b",
		"default~addinformation-addinformation-module~pages-pages-module~viewinformation-viewinformation-modu~777c1151",
		"default~pages-pages-module~previewreports-previewreports-module~viewinformation-viewinformation-modu~726601f2",
		"default~addinformation-addinformation-module~viewinformation-viewinformation-module",
		"viewinformation-viewinformation-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;